"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// A couple of polyfills in case someone still wants to use Internet Explorer
// I got these from developer.mozilla.org --love, BCC
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

/*eslint-disable */
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i); // preallocate the Array

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}

if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target, varArgs) {
      // .length of function is 2
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }

      return to;
    },
    writable: true,
    configurable: true
  });
} // From mozilla.org MDN


if (typeof window.CustomEvent !== 'function') {
  var CustomEvent = function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}
/* eslint-enable */


;

(function Core(win, doc) {
  var PPVX = {
    __VERSION__: '3.41.0',

    /**
     * @function getValue – safely fetch a value from a path in an object,
     * @param {string} path – the path to follow to get the value
     * @param {*} [defaultValue] – what to return if there is no value defined
     * for that path. Defaults to undefined.
     *
     * @returns {*} - the value represented by path, or defaultValue if any
     * segment along the path does not exist.
     *
     * getValue( { a: { b: { c: 'hello' } } }, 'a.b.c' ) will return 'hello'
     * getValue( { a: { b: { c: 'hello' } } }, 'a.b' ) will return { c: 'hello' }
     */
    getValue: function getValue(path, defaultValue) {
      var pathSteps = path.split('.') || [];
      var obj = this;
      var len = pathSteps.length; // eslint-disable-next-line no-plusplus

      for (var i = 0; i < len; ++i) {
        var step = pathSteps[i];

        if (obj[step] === null || obj[step] === undefined) {
          return defaultValue;
        }

        obj = obj[step];
      }

      if (obj === null || obj === undefined) {
        return defaultValue;
      }

      return obj;
    },

    /**
     * @function setValue – safely set a value from a path in an object,
     * @param {string} path – the path to follow to get the value
     * @param {*} value – the new value to set
     *
     * @returns {object} - the first parameter, which has been modified
     *
     * If any segment along the path is null or undefined, it will be created
     *
     * setValue( {}, 'a.b.c', 'hello' ) will return:
     * { a: { b: { c: 'hello' } } }
     *
     * setValue( { a: { b: { c: 'hello' } } }, 'a.b.c', 'goodbye' ) will return:
     * { a: { b: { c: 'goodbye' } } }
     *
     * setValue( { a: { b: { c: 'hello' } } }, 'a.b', 'goodbye' ) will return:
     * { a: { b: 'goodbye' } }
     */
    setValue: function setValue(path, value) {
      var pathSteps = path.split('.');

      if (!path || path.length < 1) {
        return null;
      }

      var name = pathSteps.pop();
      var sub = this;
      pathSteps.forEach(function (step) {
        sub[step] = sub[step] || {};
        sub = sub[step];
      });
      sub[name] = value;
      return this;
    },

    /**
     * @function deleteValue – safely remove a value from a path in an object,
     * @param {string} path – the path to find the value to delete
     *
     * @returns {boolean} - true if it found the object
     *
     * If any part of the path does not exist, deleteValue() will return false.
     */
    deleteValue: function deleteValue(path) {
      var pathSteps = path.split('.');

      if (!path || path.length < 1) {
        return false;
      }

      var name = pathSteps.pop();
      var obj = this;
      var len = pathSteps.length; // eslint-disable-next-line no-plusplus

      for (var i = 0; i < len; ++i) {
        var step = pathSteps[i];

        if (obj[step] === null || obj[step] === undefined) {
          return false;
        }

        obj = obj[step];
      }

      if (obj === null || obj === undefined) {
        return false;
      }

      delete obj[name];
      return true;
    },

    /**
     * @function setAttrs – safely set one or more values in a nested object,
     * @param {string} path – the path to follow to get the value
     * @param {object} attrs – an object with name/value pairs to set
     *
     * Any missing steps in the path will be added
     * Any attributes that were not there will be added
     * Any attributes that were already there will be overwritten
     *
     * @returns {object} - the path value object, whose contents have been modified
     *
     * Typical usage:
     * PPVX.setAttrs( 'myFeature', { attr1: value1, ... attrN: valueN } )
     *
     * This will ensure that win.PPVX and win.PPVX.myFeature exist. It will also
     * preserve any values not changed by attrs.
     *
     * If the current value specified by the path is a scalar, it will return null
     * and leave PPVX unchanged.
     */
    setAttrs: function setAttrs(path, attrs) {
      var currentAttrs = this.getValue(path, {});

      if (_typeof(currentAttrs) !== 'object' || Array.isArray(currentAttrs)) {
        return null;
      }

      if (Object.keys(currentAttrs).length === 0) {
        return this.setValue(path, attrs);
      }

      return Object.assign(currentAttrs, attrs);
    },
    getRoot: function getRoot() {
      return doc.getElementById('ppvx_root') || doc.body;
    },
    isReady: function isReady() {
      return doc.readyState === 'complete';
    },
    registerObject: function registerObject(obj, name) {
      this[name] = obj;

      if (this.isReady() && typeof obj.initOnLoad === 'function') {
        obj.initOnLoad();
      }
    },
    generateRandomId: function generateRandomId(prefix) {
      return "".concat(prefix, "-").concat(Math.random().toFixed(8).toString().replace('0.', ''));
    }
  };

  function EventWatcher(eventType) {
    var eventOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      capture: true
    };
    this.watchList = [];
    this.eventType = eventType;
    this.eventOptions = eventOptions;
  }

  Object.assign(EventWatcher.prototype, {
    addWatcher: function addWatcher(name, callback) {
      this.watchList.push({
        name: name,
        callback: callback
      });
    },
    removeWatcher: function removeWatcher(name) {
      this.watchList = this.watchList.filter(function (_ref) {
        var itemName = _ref.name;
        return name !== itemName;
      });
    },
    startWatching: function startWatching() {
      if (!this.listener) {
        // If we have a listener, we're already watching!
        this.listener = this.handler.bind(this);
        doc.addEventListener(this.eventType, this.listener, this.eventOptions);
      }
    },
    stopWatching: function stopWatching() {
      doc.removeEventListener(this.eventType, this.listener, this.eventOptions);
      this.listener = null;
    },
    handler: function handler(evt) {
      this.watchList.forEach(function (watcher) {
        watcher.callback(evt);
      });
    }
  });
  PPVX.clickWatcher = new EventWatcher('click');
  PPVX.focusWatcher = new EventWatcher('focus'); // Set up core constants

  PPVX.setAttrs('CONSTANTS', {
    breakpoints: {
      menuSheet: 752 // @ppui-grid-media-query-md

    }
  });

  if (win !== undefined) {
    // Disable rule that doesn't want parameter re-asignment
    // since we need to bind the main PPVX object into
    // the window object
    // eslint-disable-next-line
    win.PPVX = PPVX;

    if (doc !== undefined) {
      // Code to execute when all DOM content is loaded.
      var readyFunc = function readyFunc() {
        if (!PPVX.isReady()) {
          return;
        } // Loop through all immediate children and see if they have an initOnLoad function.
        // If they do, call it. Some of these will add watchers to the clickWatcher.


        Object.entries(PPVX).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              item = _ref3[1];

          if (typeof item.initOnLoad === 'function') {
            item.initOnLoad();
          }
        });
        PPVX.clickWatcher.startWatching();
        PPVX.focusWatcher.startWatching();
      }; // If document is already ready, we would wait a LONG time for a readystatechange...
      // This is the case when we're embedded in a docz page


      if (PPVX.isReady()) {
        readyFunc();
      } else {
        doc.addEventListener('readystatechange', readyFunc);
      }
    }
  }
})(window, document);